<template>
  <div
    v-outside-click="{
      exclude: [],
      handler: 'closeAddMultiTypeMenu'
    }">
    <Button class="w-32 rounded-md relative"
      ref="openButton"
      color="blue"
      @click="openAddMultiTypeMenu">
      +
      <div class="absolute inset-0 z-10"
        v-show="showSelector">
        <div class="p-1 bg-sky-200 rounded-sm">
          <div class="flex flex-col m-2 space-y-1">
            <Button class="rounded-sm"
              v-for="buttonData in filteredButtonDatas"
              :key="buttonData.type"
              color="blue"
              @click="addField(buttonData.type)">
              {{ buttonData.display }}
            </Button>
          </div>
        </div>
      </div>
    </Button>
  </div>
</template>

<script>
import Button from '../../Button.vue'

export default {
  components:{
    Button,
  },
  props: {
    options: {
      type: Array,
      default: () => ['userId', 'districtCode', 'vendorId', 'studentIds', 'keyValue'],
    },
  },
  data() {
    return {
      buttonDatas: [
        {
          type: 'userId',
          display: 'User ID',
        },
        {
          type: 'districtCode',
          display: 'District Code',
        },
        {
          type: 'vendorId',
          display: 'Vendor ID',
        },
        {
          type: 'studentIds',
          display: 'Student IDs',
        },
        {
          type: 'keyValue',
          display: 'Key-Value'
        }
      ],
      showSelector: false,
    }
  },
  computed: {
    filteredButtonDatas() {
      return this.buttonDatas.filter(btnData => this.options.includes(btnData.type))
    }
  },
  methods: {
    openAddMultiTypeMenu() {
      this.showSelector = true
    },
    closeAddMultiTypeMenu() {
      this.showSelector = false
    },
    addField(type) {
      this.$emit('addField', type)
    }
  }
}
</script>
